"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBDocDeniedPositive = function SvgBDocDeniedPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M58.972 40.807H23.535a2.25 2.25 0 110-4.5h35.438a2.25 2.25 0 110 4.5zM83.79 54.975H23.535a2.25 2.25 0 110-4.5H83.79a2.25 2.25 0 110 4.5zM83.79 69.15H23.535a2.25 2.25 0 110-4.5H83.79a2.25 2.25 0 110 4.5zM83.79 83.317H23.535a2.25 2.25 0 110-4.5H83.79a2.25 2.25 0 110 4.5z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M105.075 76.177a2.25 2.25 0 01-2.25-2.25l.045-67.5a1.2 1.2 0 00-1.2-1.2h-57.3a2.25 2.25 0 110-4.5h57.3a5.708 5.708 0 015.7 5.7l-.045 67.5a2.25 2.25 0 01-2.25 2.25z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M2.25 100.912A2.25 2.25 0 010 98.662V27.847a2.25 2.25 0 012.25-2.25h22.59V13.68a2.25 2.25 0 114.5 0v14.168a2.25 2.25 0 01-2.25 2.25H4.5v68.564a2.25 2.25 0 01-2.25 2.25z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M112.17 117.248a2.25 2.25 0 01-1.59-.653L96.555 102.57a2.25 2.25 0 013.18-3.18l14.025 14.017a2.25 2.25 0 01-1.59 3.84z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M98.145 117.248a2.25 2.25 0 01-1.59-3.84L110.58 99.39a2.25 2.25 0 113.18 3.18l-14.01 14.025a2.25 2.25 0 01-1.605.653z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M105.195 143.595H73.5a2.248 2.248 0 01-1.59-.66L54.075 125.04l-11.25 9.705a2.25 2.25 0 01-3.105-.157l-20.775-21.945-15.27 12.442A2.25 2.25 0 010 123.345V40.612a2.25 2.25 0 114.5 0v78l13.223-10.77a2.25 2.25 0 013.06.195l20.73 21.908 11.205-9.675a2.25 2.25 0 013.06.112l18.682 18.75h28.5v-9.847a2.25 2.25 0 114.5 0v12.06a2.25 2.25 0 01-2.265 2.25z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M105.203 131.512a2.25 2.25 0 110-4.5c9.558-.009 17.624-7.113 18.84-16.595 1.215-9.481-4.798-18.39-14.046-20.81-9.248-2.42-18.854 2.403-22.438 11.265-3.584 8.861-.031 19.006 8.299 23.695a2.25 2.25 0 11-2.206 3.923c-10.296-5.773-14.706-18.293-10.3-29.245 4.404-10.952 16.255-16.932 27.682-13.968 11.426 2.965 18.876 13.95 17.402 25.663-1.474 11.712-11.414 20.51-23.219 20.55l-.014.022z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M9.33 19.5a2.25 2.25 0 01-1.59-3.84L21.99 1.41a2.25 2.25 0 011.605-.66H69.75a2.25 2.25 0 010 4.5H24.525L10.92 18.855a2.25 2.25 0 01-1.59.645z",
    fill: "#1B7"
  })));
};

var _default = SvgBDocDeniedPositive;
exports["default"] = _default;